import { Component, OnInit } from '@angular/core';
import { MessService } from '../mess.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit{
  openMenu: string | null = 'master';
  isMasterOpen = false;

  isCollapsed: boolean = false;
  activeView: any = '';
  savedView: any;
  roleDetails: any;

  showMainHrms = false;
  showMealOrderSummary = false;
  showDaysheetSubmit = false;
  showMealRequest = false;
  showMessDaysheetClose = false;
  showAdminDashboardReports = false;
  showAddNewMenuItem = false;
  showMessDaysheetFusionUpdate = false;

  MainHrmslabel: any;

  mealOrderSummary: any;
  daysheetSubmit: any;
  mealRequest: any;
  messDaysheetClose:any;
  adminDashboardReports:any;
  addNewMenuItem:any;
messDaysheetFusionUpdate:any;
 
  constructor(private Service: MessService, private router: Router, private spinner: NgxSpinnerService,) {

    const storedView = localStorage.getItem('routeNames') || '';
    this.savedView = storedView;
    this.Service.setView(this.savedView);
    this.Service.view$.subscribe(view => {
      this.activeView = view;
    });

    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });
  }
  ngOnInit(): void {
    this.rolemanagement();
  }

  rolemanagement() {
    localStorage.removeItem('routeNames');
    this.spinner.show();
    const payrollId = localStorage.getItem('userId');
    // const payrollId = 'hyd110010728'
    this.Service.getRolemanagement(payrollId).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.roleDetails = res;
        console.log('this.roleDetails', this.roleDetails);

        // Prefer MEAL_ORDER_SUMMERY as active when present; else first allowed form in API order.
        // DAYSHEET_DETAILS is ignored (no menu, not used for viewToSet).
        const formToView: Record<string, string> = {
          MEAL_ORDER_SUMMERY: 'mealOrderSummary',
          DAYSHEET_SUBMIT: 'messDetailsInventory',
          MEAL_REQUEST: 'mealRequest',
          DAYSHEET_CLOSE: 'messDoDetails',
          ADD_MENU_ITEM: 'addNewMenuItem',
          ADMIN_DAYSHEET_REPORT: 'adminDashboardReports',
          MESS_DAYSHEET_FUSION_UPDATE:'messClosedDetails'
        };
        let firstAllowedView = '';
        let hasMealOrderSummary = false;
        let hasAnyMessAccess = false;

        for (const group of this.roleDetails.userAppForms) {
          if (group.formGroup === 'MESS_DAYSHEET') {
            this.Service.setReportsSelected(true);
            this.MainHrmslabel = group.formGroupLabel;
            this.showMainHrms = true;
          }
          for (const form of group.appForms) {
            const formName = String(form.appFormName ?? '').trim();
            if (formName === 'DAYSHEET_DETAILS') {
              continue;
            }

            const mappedView = formToView[formName];
            if (mappedView && !firstAllowedView) {
              firstAllowedView = mappedView;
            }

            switch (formName) {
              case 'MEAL_ORDER_SUMMERY':
                this.mealOrderSummary = form.appFormLabel;
                this.showMealOrderSummary = true;
                hasMealOrderSummary = true;
                hasAnyMessAccess = true;
                break;

              case 'DAYSHEET_SUBMIT':
                this.daysheetSubmit = form.appFormLabel;
                this.showDaysheetSubmit = true;
                hasAnyMessAccess = true;
                break;

              case 'MEAL_REQUEST':
                this.mealRequest = form.appFormLabel;
                this.showMealRequest = true;
                hasAnyMessAccess = true;
                break;

              case 'DAYSHEET_CLOSE':
                this.messDaysheetClose = form.appFormLabel;
                this.showMessDaysheetClose = true;
                hasAnyMessAccess = true;
                break;
              case 'ADMIN_DAYSHEET_REPORT':
                this.adminDashboardReports = form.appFormLabel;
                this.showAdminDashboardReports = true;
                hasAnyMessAccess = true;
                break;
              case 'ADD_MENU_ITEM':
                this.addNewMenuItem = form.appFormLabel;
                this.showAddNewMenuItem = true;
                hasAnyMessAccess = true;
                break;
              case 'MESS_DAYSHEET_FUSION_UPDATE':
                this.messDaysheetFusionUpdate = form.appFormLabel;
                this.showMessDaysheetFusionUpdate = true;
                hasAnyMessAccess = true;
                break;

              default:
                console.warn('Unhandled form:', form.appFormName);
                break;
            }
          }
        }

        // When MEAL_ORDER_SUMMERY exists in response, it is the default active view
        const viewToSet = hasMealOrderSummary
          ? 'mealOrderSummary'
          : (firstAllowedView || (hasAnyMessAccess ? 'mealOrderSummary' : 'mealOrderSummary'));
        localStorage.setItem('routeNames', viewToSet);
        this.savedView = viewToSet;
        this.Service.setView(this.savedView);
        this.spinner.hide();
      },
      error: (err: any) => {
        this.spinner.hide();
      }
    });
  }

  showtomealordersummary() {
    this.Service.setView('mealOrderSummary');
  }

  showtoDaysheetSubmit() {
    this.Service.setView('messDetailsInventory');
  }
  showtoMealRequest() {
    this.Service.setView('mealRequest');
  }
  showtomessDaysheetClose() {
    this.Service.setView('messDoDetails');
  }

  showtoAdminDashboardReports() {
    this.Service.setView('adminDashboardReports');
  }
  showtoAddNewMenuItem() {
    this.Service.setView('addNewMenuItem');
  }
  showtoMessDaysheetFusionUpdate() {
    this.Service.setView('messClosedDetails');
  }
  toggleCollapse() {
    // this.Service.toggleCollapse();
  }

  refreshComponent() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/MessDetails']);
    });
  }

  toggleMasterMenu() {
    this.isMasterOpen = !this.isMasterOpen;
  }

  toggleSubMenu(menu: string): void {
    this.openMenu = this.openMenu === menu ? null : menu;
  }

  openSidebar() {
    this.Service.openSidebar();
  }

}
